const eventTypes = {
  START_TIMER: 'START_TIMER',
  STOP_TIMER: 'STOP_TIMER',
  SEND_PING: 'SEND_PING',
};

export const SEND_PING = 'SEND_PING';
export const STOP_TIMER = 'STOP_TIMER';
export const START_TIMER = 'START_TIMER';

export default eventTypes;
